import { Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { GetProductByPathApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = {
    path: string;
    addToRecentlyViewed?: boolean;
} & HasOnSuccess<ProductModel>;
type Props = {
    apiParameter: GetProductByPathApiV2Parameter;
    apiResult: ProductModel;
};

type HandlerType = Handler<Parameter, Props>;

export const AddToExpandTokens: HandlerType = props => {
    const currentExpand = props.apiParameter.expand || [];
    props.apiParameter.expand = currentExpand.includes("properties") ? currentExpand : [...currentExpand, "properties"];
};

addToChainAfter(chain, PopulateApiParameter, AddToExpandTokens);
